var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"PictureCreate"}},[_c('PictureForm',{attrs:{"hasValorID":_vm.hasValorID,"submitForm":_vm.addRow,"buttonText":"Guardar","hasReset":"true","hasCarCreate":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }